import { Provider } from '@angular/core';
import {
  DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN,
  DECLARATIVE_FORMS_VALIDATOR_TOKEN,
  GRAPH_NODE_BUILDER_TOKEN,
} from '@fmnts/declarative-forms/core';
import { ActionGraphNodeBuilder } from './form-graph/action-node-builder.service';
import { ArrayNodeBuilder } from './form-graph/array-node-builder.service';
import { FieldGraphNodeBuilder } from './form-graph/field-node-builder.service';
import { FormGraphNodeBuilder } from './form-graph/form-node-builder.service';
import { RxjsGraphNodeBuilder } from './form-graph/rxjs-node-builder.service';
import { TemplateNodeBuilder } from './form-graph/template-node-builder.service';
import { DateTemplateService } from './template/date-template.service';
import { FormTemplateService } from './template/form-template.service';
import { CommonValidationBuilder } from './validation/common-validation-builder.service';
import { NumberRangeValidationService } from './validation/number-range-validation.service';

export function provideCommonDeclarativeFormsValidationBuilders(): Provider {
  return [
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: CommonValidationBuilder,
      multi: true,
    },
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: NumberRangeValidationService,
      multi: true,
    },
  ];
}

export function provideCommonDeclarativeFormsTemplateBuilders(): Provider {
  return [
    {
      provide: DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN,
      useClass: FormTemplateService,
      multi: true,
    },
    {
      provide: DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN,
      useClass: DateTemplateService,
      multi: true,
    },
  ];
}

export function provideCommonDeclarativeFormsGraphNodeBuilders(): Provider {
  return [
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: FieldGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: FormGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: RxjsGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: ArrayNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useClass: TemplateNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      // This will make sure that the injected ActionService has the right actions
      useClass: ActionGraphNodeBuilder,
      multi: true,
    },
  ];
}

export function provideCommonDeclarativeFormsFeatures(): Provider {
  return [
    provideCommonDeclarativeFormsGraphNodeBuilders(),
    provideCommonDeclarativeFormsTemplateBuilders(),
    provideCommonDeclarativeFormsValidationBuilders(),
  ];
}
